export const RULES_SHOW_RADIO_PERIOD = 1;
export const RULES_SHOW_RADIO_TEACHERS = 2;
export const RULES_SHOW_RADIO_PERIOD_PREFS = 3;
export const RULES_SHOW_RADIO_ROOMS = 4;
export const RULES_SHOW_RADIO_ASSIGNED_TEACHERS = 5;
export const RULES_SHOW_RADIO_ASSIGNED_ROOMS = 6;
export const RULES_TOTAL_PERIOD_DATATABLE_SHOW_KEY = "totalPeriodShow";